import { V_FORM_ENUM } from '@/CommonDP/VForm/utils';
export const schema = {
  group: V_FORM_ENUM.custom, // 组件类型
  type: 'jy-prj-name', // 唯一名称
  icon: 'html-text',
  label: '项目名称(仅显示)',
  formItemFlag: true, // 是否需嵌套于el-form-item
  component: require('./index.vue').default,
  props() {
    return {
      mapPrjNameTo: () => import('./settings.vue')
    };
  },
  options: {
    name: '',
    label: '项目名称',
    labelHidden: false,
    labelWidth: '',
    labelWrap: false, // 自动换行
    position: '',
    labelAlign: '',
    disabled: false,
    hidden: false,
    required: false,
    requiredHint: ' ',
    size: '',
    columnWidth: '200px',
    // 自定义属性
    mapPrjNameTo: '',
    mapPrjCodeTo: ''
  }
};
